import React from "react";

const CartColumns = () => {
  return (
    <div className="cart__heading">
      <h5>Description</h5>
      <h5>Price</h5>
      <h5>Quantity</h5>
      <h5>Remove</h5>
      <h5>Subtotal</h5>
    </div>
  );
};

export default CartColumns;
